const config = {
    api : 'https://carfinds.pythonanywhere.com/api/v1/cars/?page=',
    token: 'Token 282bc98780517b27f0154742eddb58ae47c9dbd4'
}
export { config };
